// src/pages/LandingPage.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { styles } from '../styles/newstyles';

function RecycleButtonInline() {
  const navigate = useNavigate();

  const btn = {
    width: 56,
    height: 56,
    position: 'absolute',
    bottom: '50px',
    right: '20px',
    borderRadius: '9999px',
    background: 'linear-gradient(180deg, #1f6feb 0%, #0c4aad 100%)',
    color: '#fff',
    border: '2px solid #ffffffaa',   // semi-transparent white border
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: '0 10px 24px rgba(31,111,235,0.28), 0 6px 12px rgba(0,0,0,0.12)',
    transition: 'transform 160ms ease, box-shadow 160ms ease',
  };


  const iconWrap = { width: 28, height: 28, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' };

  return (
    <button
      type="button"
      aria-label="Open Recycle Bin"
      title="Recycle Bin"
      onClick={() => navigate('/recyclebin')}
      style={btn}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px) scale(1.03)';
        e.currentTarget.style.boxShadow =
          '0 14px 32px rgba(31,111,235,0.36), 0 10px 16px rgba(0,0,0,0.16)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'none';
        e.currentTarget.style.boxShadow =
          '0 10px 24px rgba(31,111,235,0.28), 0 6px 12px rgba(0,0,0,0.12)';
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') navigate('/recyclebin');
      }}
    >
      {/* Trash icon (inline SVG) */}
      <span aria-hidden style={iconWrap}>
        <svg
          viewBox="0 0 24 24"
          width="24"
          height="24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 6h18" />
          <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
          <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
          <path d="M10 11v6M14 11v6" />
        </svg>
      </span>
    </button>
  );
}

const LandingPage = ({ onLogout, isAdmin, username, canEditRestricted, canEditDomains, canEditCategories }) => {
  const navigate = useNavigate();
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);
  const [installLabel, setInstallLabel] = useState('Install app');
  const linkBtn = {
    appearance: 'none',
    background: 'transparent',
    color: '#2563eb',
    fontWeight: 600,
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    textDecoration: 'underline',
  };


  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    // Hide CTA entirely if we're already running as an installed app
    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    if (isStandalone) {
      setShowInstall(false);
      return undefined;
    }

    // if global prompt was already captured (e.g., first page load), show CTA immediately
    if (typeof window !== 'undefined' && window.__typortalInstallPrompt) {
      setDeferredPrompt(window.__typortalInstallPrompt);
      setShowInstall(true);
    }

    if (typeof navigator !== 'undefined') {
      const ua = navigator.userAgent || '';
      const isMobile =
        /android|iphone|ipad|ipod/i.test(ua) ||
        (typeof window !== 'undefined' &&
          window.matchMedia &&
          window.matchMedia('(pointer: coarse)').matches);
      setInstallLabel(isMobile ? 'Add to Home screen' : 'Install on this device');
    }

    const onBip = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstall(true);
      window.__typortalInstallPrompt = e;
    };

    const onAppInstalled = () => {
      setShowInstall(false);
      setDeferredPrompt(null);
      if (typeof window !== 'undefined') {
        window.__typortalInstallPrompt = null;
      }
    };

    window.addEventListener('beforeinstallprompt', onBip);
    window.addEventListener('appinstalled', onAppInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onBip);
      window.removeEventListener('appinstalled', onAppInstalled);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setShowInstall(false);
    window.__typortalInstallPrompt = null;
  };

  // Keep cards lightweight so we don't touch global styles
  const card = {
    flex: 1,
    minWidth: 280,
    borderRadius: 16,
    boxShadow: '0 10px 24px rgba(0,0,0,0.08)',
    border: '1px solid #e6eefc',
    padding: '24px',
    cursor: 'pointer',
    transition: 'transform .12s ease, box-shadow .12s ease',
    background: '#fff',
  };

  return (
    <div style={styles.mainContainer}>
      <Navbar username={username} onLogout={onLogout} isAdmin={isAdmin} />

      <div style={{ maxWidth: 1200, margin: '-50px auto', padding: '0px' }}>
        {/* <h1 style={{ color: '#023e8a', marginBottom: 16 }}>Welcome(heading)</h1> */}
        {/* <p style={{ margin: '0 0 24px' }}>Sub heading 2</p> */}
        {/* <div onClick={() => navigate('/add')}>
           <p style={{ margin: '0 0 24px',textDecoration: 'underline',cursor:'pointer' }}>Upload a document click here </p>
          </div> */}

          <ul style={{ margin: '10px 14px', paddingLeft: 18, color: '#111827', lineHeight: 1.7 }}>
            <li>
              Upload a document {' '}
              <button
                type="button"
                onClick={() => navigate('/add')}
                style={linkBtn}
              >
                Click here
              </button>
            </li>
            {isAdmin && canEditDomains && (
              <li>
                Add / Update email domain {' '}
                <button
                  type="button"
                  onClick={() => navigate('/tools')}
                  style={linkBtn}
                >
                  Click here
                </button>
              </li>
            )}
            {isAdmin && canEditCategories && (
              <li>
                Add / Update category, type {' '}
                <button
                  type="button"
                  onClick={() => navigate('/tools/attachments')}
                  style={linkBtn}
                >
                  Click here
                </button>
              </li>
            )}
            {isAdmin && canEditRestricted && (
              <li>
                Edit restricted users {' '}
                <button
                  type="button"
                  onClick={() => navigate('/tools/restricted')}
                  style={linkBtn}
                >
                  Click here
                </button>
              </li>
            )}
          </ul>
        {showInstall && (
          <div style={{ margin: '12px 10px' }}>
            <button
              type="button"
              onClick={handleInstall}
              style={{
                padding: '10px 16px',
                borderRadius: 10,
                border: '1px solid #1f6feb',
                background: 'linear-gradient(180deg,#1f6feb 0%,#0c4aad 100%)',
                color: '#fff',
                fontWeight: 700,
                cursor: 'pointer',
                boxShadow: '0 8px 18px rgba(31,111,235,0.25)'
              }}
            >
              {installLabel}
            </button>
          </div>
        )}
       

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 20 }}>
          {/* Documents → Home */}
          <div
            role="button"
            tabIndex={0}
            style={card}
            onClick={() => navigate('/home')}
            onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/home')}
          >
            <h2 style={{ margin: 0, color: '#023e8a' }}> Manage Documents</h2>
            <p style={{ marginTop: 8 }}>Browse, filter, and manage uploaded files.</p>
          </div>

          {/* Tax Payers → Owner Details */}
          <div
            role="button"
            tabIndex={0}
            style={card}
            onClick={() => navigate('/owner-details')}
            onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/owner-details')}
          >
            <h2 style={{ margin: 0, color: '#023e8a' }}>Owners</h2>
            <p style={{ marginTop: 8 }}>View owner details and related information.</p>
          </div>
        </div>

        {/* CAO card placed below to avoid shrinking other cards */}
        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-start' }}>
          <div
            role="button"
            tabIndex={0}
            style={{ ...card, maxWidth: 540 }}
            onClick={() => navigate('/cao')}
            onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/cao')}
          >
            <h2 style={{ margin: 0, color: '#023e8a' }}>Chief Dash Board</h2>
            <p style={{ marginTop: 8 }}>Access reports</p>
          </div>
        </div>

        {/* Inline (relative) dustbin — at the bottom of page content, scrolls away with content */}
        <div
          style={{
            marginTop: 28,
            display: 'flex',
            justifyContent: 'flex-end',
            // give it breathing room above the footer
            paddingBottom: 12,
          }}
        >
          <RecycleButtonInline />
        </div>
      </div>
    </div>
  );
};

export default LandingPage;




















































// // src/pages/LandingPage.jsx
// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import Navbar from '../components/Navbar';
// import { styles } from '../styles/newstyles';

// const LandingPage = ({ onLogout, isAdmin, username }) => {
//   const navigate = useNavigate();

//   // Keep cards lightweight so we don't touch global styles
//   const card = {
//     flex: 1,
//     minWidth: 280,
//     borderRadius: 16,
//     boxShadow: '0 10px 24px rgba(0,0,0,0.08)',
//     border: '1px solid #e6eefc',
//     padding: '24px',
//     cursor: 'pointer',
//     transition: 'transform .12s ease, box-shadow .12s ease',
//     background: '#fff',
//   };

//   return (
//     <div style={styles.mainContainer}>
//       <Navbar username={username} onLogout={onLogout} isAdmin={isAdmin} />

//       <div style={{ maxWidth: 1200, margin: '0 auto', padding: '24px' }}>
//         <h1 style={{ color: '#023e8a', marginBottom: 16 }}>Welcome</h1>
//         <p style={{ margin: '0 0 24px' }}>Choose where you’d like to go:</p>

//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 20 }}>
//           {/* Documents → Home */}
//           <div
//             role="button"
//             tabIndex={0}
//             style={card}
//             onClick={() => navigate('/home')}
//             onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/home')}
//           >
//             <h2 style={{ margin: 0, color: '#023e8a' }}>Documents</h2>
//             <p style={{ marginTop: 8 }}>Browse, filter, and manage uploaded files.</p>
//           </div>

//           {/* Tax Payers → Owner Details */}
//           <div
//             role="button"
//             tabIndex={0}
//             style={card}
//             onClick={() => navigate('/owner-details')}
//             onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && navigate('/owner-details')}
//           >
//             <h2 style={{ margin: 0, color: '#023e8a' }}>Tax Payers</h2>
//             <p style={{ marginTop: 8 }}>View owner details and related information.</p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LandingPage;
